import React, { useState } from 'react';
import facts from "../static/factsList.json";

function Facts() {
  const [currentTip, setTip] = useState(facts[Math.floor(Math.random() * facts.length)]);

  const handleClick = () => {
    return setTip(facts[Math.floor(Math.random() * facts.length)]);
  }

  return (
    <div className="facts">
      <button className="facts__button" onClick={ handleClick }>Next</button>
      <h3 className="facts__heading">{ currentTip.title }</h3>
      <div className="facts__content">{ currentTip.content }</div>
    </div>
  )
}

export default Facts;
